import * as React from "react";
import { useWebGPUSurvey } from "../hooks/useWebGPUSurvey";

const WebGPUSurvey: React.FC = () => {
  useWebGPUSurvey();

  return null;
};

export default WebGPUSurvey;
